import React from 'react';
import { Platform, View } from 'react-native';
import { StatusBar } from 'expo-status-bar';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { Provider } from 'react-redux';
import { store } from './src/store';
import { ThemeProvider, useTheme } from './src/theme/ThemeContext';
import { AppNavigator } from './src/navigation/AppNavigator';

// Inject Web layout resets for desktop & mobile browser rendering
if (Platform.OS === 'web' && typeof document !== 'undefined') {
  const styleEl = document.createElement('style');
  styleEl.textContent = `
    html, body, #root, #root > div {
      height: 100%;
      min-height: 100vh;
      width: 100%;
      display: flex;
      flex-direction: column;
      margin: 0;
      padding: 0;
      background-color: #F8FAFC;
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
      box-sizing: border-box;
    }
    *, *:before, *:after {
      box-sizing: border-box;
    }
    input, textarea, select, button {
      outline: none !important;
      font-family: inherit;
    }
  `;
  document.head.appendChild(styleEl);
}

const MainApp = () => {
  const { colors } = useTheme();

  return (
    <SafeAreaProvider style={{ flex: 1, backgroundColor: colors.bg }}>
      <StatusBar style="dark" />
      <View style={{ flex: 1, width: '100%', minHeight: Platform.OS === 'web' ? '100vh' : '100%' }}>
        <AppNavigator />
      </View>
    </SafeAreaProvider>
  );
};

export default function App() {
  return (
    <Provider store={store}>
      <ThemeProvider>
        <MainApp />
      </ThemeProvider>
    </Provider>
  );
}

